import { Icon } from "./Icon.tsx";

/** Generic node-group icon (ElementBrowser.tsx's own "Nodes" header) — a plain circle, same shape as AddJunctionIcon.tsx's own node dot but centered and without its "+" badge (this represents the whole mixed-kind group, not the single "add a junction" action). */
export function NodeIcon() {
  return (
    <Icon>
      <circle cx="12" cy="12" r="6" />
    </Icon>
  );
}
